import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import PedidoDeCompraService from "./PedidoDeCompraService";
import PedidoDeCompraParcelas from "./PedidoDeCompraParcelasService";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import ContasAPagarService from "./ContasAPagarService";
import UtilDateTime from "@/utils/UtilDateTime";
import UtilNumber from "@/utils/UtilNumber";
import UtilArray from "../../../utils/UtilArray.mjs";

export default {

    async enviarPedidoParaFornecedor(pedidoDeCompraID = "", emailFornecedorValores = {}){

        let pedidoDeCompra
        let pedidoDeCompraEnviado;
        let ordensDeServicoItem;

        try{

            //==================================================================//
            //===================== Pega Pedido de Compra ======================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw new Error("Pedido de Compra não encontrado");
            }

            //==================================================================//
            //======================== Pega Fornecedor =========================//
            //==================================================================//

            let fornecedor = await ERP.getOneById(Schema.FORNECEDOR, pedidoDeCompra?.data?.fornecedor);
            if(fornecedor.status != 200){
                throw new Error("Fornecedor não encontrado");
            }

            //==================================================================//
            //=============== Pega os Itens do Pedido de Compra ================//
            //==================================================================//

            let pedidoDeCompraItensIDs = pedidoDeCompra?.data?.itens;

            let pedidoDeCompraItens = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_ITENS, pedidoDeCompraItensIDs);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            //==================================================================//
            //=================== Pega Ordem de Serviço Item ===================//
            //==================================================================//

            let ordensDeServicoItemIDs = pedidoDeCompraItens?.data?.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            let ordensDeServicoItem = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordensDeServicoItemIDs);
            if(ordensDeServicoItem.status != 200){
                throw ordensDeServicoItem;
            }

            //==================================================================//
            //=============== Pega Parcelas do Pedido de Compra ================//
            //==================================================================//

            let pedidoDeCompraParcelasIDs = pedidoDeCompra?.data?.parcelas;

            let pedidoDeCompraParcelas = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_PARCELAS, pedidoDeCompraParcelasIDs);
            if(pedidoDeCompraParcelas.status != 200){
                throw new Error("Parcelas do Pedido de Compra não encontrado");
            }

            //==================================================================//
            //=============== Ordena Parcelas do Pedido de Compra ==============//
            //==================================================================//

            pedidoDeCompraParcelas.data = pedidoDeCompraParcelas.data.sort((pedidoDeCompraParcela_A,pedidoDeCompraParcela_B)=>{

                return pedidoDeCompraParcela_A.codigo - pedidoDeCompraParcela_B.codigo;

            });

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=============== Cria as Parcelas de Contas a Pagar ===============//
            //==================== Separa Parcelas novas =======================//
            //==================================================================//

            let pedidoDeCompraParcelasNovas = pedidoDeCompraParcelas?.data?.reduce((acc,pedidoDeCompraParcela)=>{

                if(!pedidoDeCompraParcela?.contaAPagar){

                    acc.push(pedidoDeCompraParcela);
                }

                return acc;

            },[]);

            //==================================================================//
            //============== Cria as Parcelas de Contas a Pagar ================//
            //=============== Verifica se Tem Parcelas Novas ===================//
            //==================================================================//

            let temParcelasNovas = UtilArray.isNotEmpty(pedidoDeCompraParcelasNovas);

            //==================================================================//
            //============== Cria as Parcelas de Contas a Pagar ================//
            //==================================================================//

            let contasAPagarNovas;

            if(temParcelasNovas){

                let filialDeltaDuconID = "c511a33d-6b85-4cdf-88af-6a221f0eb46d";

                let contasAPagarNovasValores = pedidoDeCompraParcelasNovas.map((parcela,index)=>{

                    return {
                        origem: "Pedido de Compra",
                        pagamentoForma: fornecedor?.data?.pagamentoForma,
                        pagamentoTipo: parcela.tipo,
                        pagamentoEvento: parcela.referenciaEvento,
                        descricao: parcela?.descricao,
                        sequencia: index + 1,
                        filial: filialDeltaDuconID,
                        status: "Prevista",
                        pedidoDeCompra: pedidoDeCompra?.data?.id,
                        pedidoDeCompraParcela: parcela?.id,
                        favorecidoFornecedor: fornecedor?.data.id,
                        dataVencimento: UtilDateTime.toFormatUTC({dateTime:parcela?.dataVencimento}),
                        valorOriginal: UtilNumber.round(parcela?.valor),
                        valorParaReservar: UtilNumber.round(parcela?.valor),
                        valorDesconto: 0,
                        valorPagamento: 0,
                        valorReservado: 0,
                        valorParaPagar: 0,
                        valorPago: 0,
                        valorParaVincular: 0,
                        valorVinculado: 0,
                    }

                });

                contasAPagarNovas = await ContasAPagarService.criarContasAPagar(contasAPagarNovasValores);
                if(contasAPagarNovas.status != 200){
                    throw new Error("Falha ao Criar as Contas a Pagar");
                }

            }

            //==========================================================================//
            //================== Cria as Parcelas de Contas a Pagar ====================//
            //=== Adiciona a Relação de Contas a Pagar a Parcela do Pedido de Compra ===//
            //==========================================================================//

            if(temParcelasNovas){

                let pedidoDeCompraParcelasAlterarValores = contasAPagarNovas.data.map((contaAPagarNova)=>{

                    return{
                        id: contaAPagarNova.pedidoDeCompraParcela,
                        contaAPagar: contaAPagarNova.id
                    }

                });
    
                let pedidoDeCompraParcelasAlterar = await PedidoDeCompraParcelas.alteraParcelas(pedidoDeCompraParcelasAlterarValores);
                if(pedidoDeCompraParcelasAlterar.status != 200){
                    throw new Error("Falha em relacionar as Contas a Pagar com suas respectivas Parcelas do Pedido de Compra");
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //============================================================================//
            //==================== Altera as Ordens de Serviço Itens =====================//
            //=== Separa Ordens de Serviço Itens que devem ser alteradas de AE para GP ===//
            //============================================================================//

            let ordensDeServicoItemAlterar = ordensDeServicoItem?.data?.reduce((acc,ordemDeServicoItem)=>{

                if(ordemDeServicoItem?.status == "AE"){

                    acc.push(ordemDeServicoItem);
                }

                return acc;

            },[]);

            //============================================================================//
            //==================== Altera as Ordens de Serviço Itens =====================//
            //========= Verifica se Tem Ordens de Servico Item para Alterar ==============//
            //============================================================================//

            let temOrdensDeServicoItemParaAlterar = UtilArray.isNotEmpty(ordensDeServicoItemAlterar);

            //==================================================================//
            //============== Altera as Ordens de Serviço Itens =================//
            //==================================================================//

            if(temOrdensDeServicoItemParaAlterar){

                let ordensDeServicoItemAlterarValores = ordensDeServicoItemAlterar.map((ordemDeServicoItem)=>{

                    return{
                        id: ordemDeServicoItem.id,
                        status: "GP"
                    }

                });

                ordensDeServicoItemAlterar = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItemAlterarValores);
                if(ordensDeServicoItemAlterar.status != 200){
                    throw new Error("Alterar Ordem de Serviço Itens falhou");
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //==================== Altera Pedido de Compra =====================//
            //==================================================================//

            let pedidoDeCompraValores = {
                id: pedidoDeCompra?.data?.id,
                status: "Pedido em Execução"
            }

            pedidoDeCompra = await PedidoDeCompraService.alterarPedido(pedidoDeCompraValores);
            if(pedidoDeCompra.status != 200){
                throw new Error("Cancelar Pedido de Compra falhou");
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //================ Envia o Pedido para o Fornecedor ================//
            //==================================================================//

            // Comentado do Lado do Joseph afim de poder realizar testes e outros em Pedido de Compra.
            
            // let emailFornecedor = await ERP.sendGridEmail(emailFornecedorValores);
            // if(emailFornecedor.status != 200){
            //     throw new Error("Falha ao Enviar o Email para o Fornecedor");
            // }
            
            // console.log(emailFornecedor);

        }catch(e){

            console.log(e);
            return pedidoDeCompraEnviado;

        }

        //==================================================================//
        //======================= Resposta Especial ========================//
        //==================================================================//

        let response = {
            data:{
                pedidoDeCompra: pedidoDeCompra?.data,
                emailFornecedor: emailFornecedorValores,
                ordemDeServicoItens: ordensDeServicoItem?.data,
            },
            statusText: "",
            status: 200
        };

        console.log(response);

        return response;

    },

}


